export default __webpack_public_path__ + "static/media/bezier.446c14eb.gif";